
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class networkUser extends Vue {

    @Prop() item: OM.NetworkUserVm;
    @Prop() canWa: boolean;

    get whatsappLink(){
        let phone = this.item.telephone.replaceAll(" ","");
        phone = phone.replaceAll("+", "");
        while(phone.startsWith('0')){
            phone = phone.replace("0", "");
        }
        let ris = `https://api.whatsapp.com/send?phone=${phone}`;
        return ris;
    }

}
